import React from 'react';

export default function Contact() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.093"
      height="24.093"
      viewBox="0 0 24.093 24.093"
      fill="#fff"
    >
      <defs />
      <path
        className="a"
        d="M12.05,0h-.006a12.039,12.039,0,0,0-9.75,19.107l-1.5,4.475,4.63-1.48A12.044,12.044,0,1,0,12.05,0Zm7.01,17.011a3.4,3.4,0,0,1-2.364,1.7c-.629.134-1.452.241-4.219-.906-3.54-1.467-5.82-5.064-6-5.3A6.88,6.88,0,0,1,5.047,8.874,3.846,3.846,0,0,1,6.279,5.942,1.75,1.75,0,0,1,7.511,5.51c.149,0,.283.008.4.014.354.015.532.036.765.595.291.7,1,2.429,1.083,2.607a.717.717,0,0,1,.051.652,2.082,2.082,0,0,1-.39.553c-.178.2-.346.361-.524.581-.163.191-.346.4-.142.75a10.692,10.692,0,0,0,1.955,2.429,8.856,8.856,0,0,0,2.825,1.742.762.762,0,0,0,.849-.134,14.575,14.575,0,0,0,.941-1.247.672.672,0,0,1,.864-.262c.325.113,2.046.964,2.4,1.14s.587.262.673.411A3,3,0,0,1,19.059,17.011Z"
      />
    </svg>
  );
}
